export enum VariableBenefitPaymentFrequencyEnum {
  Monthly = 1,
  Annual = 2
}
